import React from 'react';
import { Spin } from 'antd';
import NoDataState from '../../../RnRCommonComponent/noDataState/NoDataState.jsx';
import {
	formatLeaderboardPoints,
	formatLeaderboardPosition,
} from '../../../_shared/services/leaderboard.js';
import { useSelector } from 'react-redux';
import { PhoneExpandable } from 'src/_shared/components/phone-expandable';

const RewardsLeaderBoard = (props) => {
	const {
		isLoading,
		selectedFilter,
		setSelectedFilter,
		showSubCompanyFilter,
		leaderBoard,
		branchLeaderboard,
	} = props;
	const currentUser = useSelector((state) => state?.user?.currentUser);
	const subCompanyLabel = currentUser?.company?.subCompanyLabel || 'SubCompany';

	const currentLeaderboard =
		selectedFilter === 'all' ? leaderBoard : branchLeaderboard;
	const filterOptions = [
		{ key: 'all', label: 'All' },
		...(showSubCompanyFilter
			? [{ key: 'subcompany', label: `My ${subCompanyLabel}` }]
			: []),
	];

	return (
		<div className="reward-leaderboard-card">
			<div className="d-flex justify-content-between align-items-center mb-3">
				<h4 className="reward-leaderboard-card-title">
					Recognition Leaderboard
				</h4>
			</div>
			{filterOptions.length > 1 && (
				<div className="d-flex flex-wrap mb-3" style={{ gap: '16px' }}>
					{filterOptions.map((option, index) => (
						<React.Fragment key={option.key}>
							<span
								onClick={() => setSelectedFilter(option.key)}
								style={{
									fontSize: '14px',
									fontWeight: selectedFilter === option.key ? 'bold' : 'normal',
									color: selectedFilter === option.key ? '#1890ff' : '#666',
									cursor: 'pointer',
									userSelect: 'none',
								}}
							>
								{option.label}
							</span>
							{index < filterOptions.length - 1 && (
								<span style={{ color: '#ccc', fontSize: '14px' }}>|</span>
							)}
						</React.Fragment>
					))}
				</div>
			)}
			{isLoading ? (
				<div
					style={{
						minHeight: 293,
						display: 'flex',
						alignItems: 'center',
					}}
				>
					<Spin className="d-flex align-items-center justify-content-center w-100 h-100" />
				</div>
			) : currentLeaderboard?.length > 0 ? (
				<PhoneExpandable collapsedHeight={300}>
					<div className="reward-leaderboard-list-scroll">
						{currentLeaderboard.map((data) => (
							<div
								key={data.position}
								className="reward-leaderboard-list d-flex justify-content-between align-items-center py-1"
							>
								<div className="reward-leaderboard-list-name d-flex align-items-center">
									<div className={data.isUser ? 'pr-1 text-blue' : 'pr-1'}>
										{formatLeaderboardPosition(data)}.
									</div>
									<div className={data.isUser ? 'pr-1 text-blue' : 'pr-1'}>
										{data?.fullName}
									</div>
								</div>
								<div
									className={
										data.isUser
											? 'reward-leaderboard-list-points-blue'
											: 'reward-leaderboard-list-points'
									}
								>
									{formatLeaderboardPoints(data)}
								</div>
							</div>
						))}
					</div>
				</PhoneExpandable>
			) : (
				<NoDataState title={'No leaders found yet.'} />
			)}
		</div>
	);
};

export default RewardsLeaderBoard;
